import { Phone } from './index';

export class Brand {
  id: string;
  name: string;
  phones;

  constructor({id, name, phones}) {
    this.id = id;
    this.name = name;
    const mapItems = phones.map(phone => {
      phone.brand = this;
      return [phone.id, new Phone(phone)];
    });
    this.phones = new Map(mapItems);
    // console.log('phones map', this.phones);
  }

  get phoneNames() {
    return this.phones.map(p => {
      return {
        id: p.id,
        name: p.name
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/models/brand.ts